var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "rotate(-180 20 20)",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.914 19.086L16.33 9.469c-.558-.525-1.411-.525-1.936 0a1.387 1.387 0 000 1.937l8.632 8.632-8.632 8.632c-.525.558-.525 1.411 0 1.936.525.525 1.378.525 1.936 0l9.584-9.584c.525-.558.525-1.411 0-1.936z",
    fill: "#FFFCFC"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAyMCAyMCkiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUuOTE0MSAxOS4wODU5TDE2LjMzMDMgOS40NjkyNUMxNS43NzI0IDguOTQ0MTEgMTQuOTE5IDguOTQ0MTEgMTQuMzkzOSA5LjQ2OTI1QzEzLjg2ODcgOS45OTQzOSAxMy44Njg3IDEwLjg4MDYgMTQuMzkzOSAxMS40MDU3TDIzLjAyNTggMjAuMDM3N0wxNC4zOTM5IDI4LjY2OTdDMTMuODY4NyAyOS4yMjc3IDEzLjg2ODcgMzAuMDgxIDE0LjM5MzkgMzAuNjA2MUMxNC45MTkgMzEuMTMxMyAxNS43NzIzIDMxLjEzMTMgMTYuMzMwMyAzMC42MDYxTDI1LjkxNDEgMjEuMDIyM0MyNi40MzkzIDIwLjQ2NDQgMjYuNDM5MyAxOS42MTEgMjUuOTE0MSAxOS4wODU5WiIgZmlsbD0iI0ZGRkNGQyIvPgo8L3N2Zz4K";
export { SvgRightNavigation as ReactComponent };